import { render } from "./HomeTwoPage.vue?vue&type=template&id=48d25ed3"
import script from "./HomeTwoPage.vue?vue&type=script&lang=js"
export * from "./HomeTwoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__